import React, { useState } from 'react';

const Logo = ({ className = '', imageClassName = 'h-10 w-auto md:h-12' }) => {
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <a
      href="/"
      className={`inline-flex items-center rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 ${className}`}
      aria-label="FontifyText home"
    >
      {imageFailed ? (
        <span className="text-2xl font-black tracking-tight text-purple-700">
          FontifyText
        </span>
      ) : (
        <picture>
          <source srcSet="/fontify-text-logo.webp" type="image/webp" />
          <img
            src="/fontify-text-logo.png"
            alt="FontifyText"
            width="224"
            height="53"
            decoding="async"
            loading="eager"
            fetchPriority="high"
            className={imageClassName}
            onError={() => setImageFailed(true)}
          />
        </picture>
      )}
    </a>
  );
};

export default Logo;
